import CoverageOptionsWrapper from '../shared/CoverageItemsWrapper';
import CoverageButton from '../shared/CoverageButton';
import type { AmendatoryLineItemProps } from '../AmendatoryCoverageLineItemFactory';
import { ContextTypes } from '../manager';
import { Modal } from '../../../../../../../../../../components/modals/v2/helpers/v2.modal.helpers';
import {
  type PropertyManagerName,
  PropertyManagerNamesModalConfig,
} from '../../modals/PropertyManagerNamesModal';

const PropertyManagerNames = (props: AmendatoryLineItemProps) => {
  if (props.contextType !== ContextTypes.UNDERWRITER) {
    return null;
  }

  const names = (props.value?.props?.items?.values ??
    []) as PropertyManagerName[];

  const saveNames = (nextNames: PropertyManagerName[]) =>
    props.setCoverage({
      id: props.id,
      value: { props: { items: { values: nextNames } } },
    });

  return (
    <CoverageOptionsWrapper>
      <CoverageButton
        disabled={!props.isSelected}
        onClick={Modal.deferShow(PropertyManagerNamesModalConfig, {
          data: { names, onSubmit: saveNames },
        })}
      >
        Add/Edit ({String(names.length)})
      </CoverageButton>
    </CoverageOptionsWrapper>
  );
};

export default PropertyManagerNames;
